import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinistries = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	viewBox: "0 0 360 360",
	"sodipodi:docname": "ministries1.svg",
	"inkscape:version": "1.2.2 (b0a8486, 2022-12-01)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs7" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview5",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			showgrid: "false",
			"inkscape:zoom": .65555556,
			"inkscape:cx": 103.72881,
			"inkscape:cy": 180,
			"inkscape:window-width": 1309,
			"inkscape:window-height": 456,
			"inkscape:window-x": 2675,
			"inkscape:window-y": 562,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "a"
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "scale(2.000) translate(-90, -90)",
			fill: "#000000",
			stroke: "none",
			children: /* @__PURE__ */ _jsx("path", {
				d: "m 175.98,173.26 c 0.08,0.73 -0.2,1.48 -0.73,2 -0.48,0.48 -1.1,0.73 -1.78,0.73 h -0.23 l -54.3,-5.28 c -1.28,-0.13 -2.25,-1.2 -2.25,-2.48 0,-1.28 0.9,-2.4 2.13,-2.58 28.6,-4.23 42.59,-18.22 46.79,-46.82 0.2,-1.23 1.25,-2.13 2.48,-2.13 1.3,0 2.5,0.98 2.63,2.25 l 5.26,54.3 z M 121.2,121.2 c -6.09,6.09 -6.09,15.97 0,22.06 6.09,6.09 15.97,6.09 22.06,0 6.09,-6.09 6.09,-15.97 0,-22.06 -6.09,-6.09 -15.97,-6.09 -22.06,0 z m 119.97,44.45 c -28.6,-4.23 -42.59,-18.22 -46.79,-46.82 -0.18,-1.23 -1.25,-2.13 -2.48,-2.13 h -0.12 c -1.28,0 -2.35,0.98 -2.48,2.25 l -5.28,54.3 c -0.08,0.73 0.2,1.48 0.73,2 0.48,0.48 1.13,0.73 1.78,0.73 h 0.25 l 54.28,-5.28 c 1.28,-0.13 2.25,-1.3 2.25,-2.6 0,-1.23 -0.9,-2.28 -2.13,-2.45 z M 216.74,121.2 c -6.09,6.09 -6.09,15.97 0,22.06 6.09,6.09 15.97,6.09 22.06,0 6.09,-6.09 6.09,-15.97 0,-22.06 -6.09,-6.09 -15.97,-6.09 -22.06,0 z m -41.48,63.55 c -0.53,-0.53 -1.28,-0.8 -2,-0.73 l -54.3,5.26 c -1.28,0.13 -2.25,1.33 -2.25,2.6 0,1.27 0.9,2.3 2.13,2.48 28.6,4.2 42.59,18.22 46.79,46.82 0.2,1.23 1.25,2.13 2.48,2.13 h 0.12 c 1.3,0 2.38,-0.98 2.5,-2.25 L 172.81309,219.55589 175.99,186.76 c 0.08,-0.75 -0.2,-1.48 -0.73,-2 z m -32,54.05 c 6.09,-6.09 6.09,-15.97 0,-22.06 -6.09,-6.09 -15.97,-6.09 -22.06,0 -6.09,6.09 -6.09,15.97 0,22.06 6.09,6.09 15.97,6.09 22.06,0 z m 97.78,-49.52 -54.28,-5.26 c -0.73,-0.07 -1.5,0.2 -2.03,0.73 -0.53,0.53 -0.8,1.25 -0.73,2 l 5.28,54.3 c 0.13,1.28 1.3,2.25 2.6,2.25 1.23,0 2.3,-0.9 2.48,-2.13 4.2,-28.6 18.19,-42.62 46.79,-46.82 1.23,-0.18 2.13,-1.33 2.13,-2.58 0,-1.25 -0.98,-2.38 -2.25,-2.5 z m -2.24,49.52 c 6.09,-6.09 6.09,-15.97 0,-22.06 -6.09,-6.09 -15.97,-6.09 -22.06,0 -6.09,6.09 -6.09,15.97 0,22.06 6.09,6.09 15.97,6.09 22.06,0 z",
				fill: "#ffffff",
				id: "path2",
				"sodipodi:nodetypes": "ccsccsccscccsssssccsscccsccsccssssscccsccsscccccsssssccsccsccsccsssss",
				style: { fill: "#000000" }
			})
		})
	]
});
export default SvgMinistries;
